/**
 * Admin Portal Pots Reset API Client
 *
 * This file provides the API client for resetting pot data in development.
 */
import { apiClient } from '../../../shared/api/axiosClient';

/**
 * Response from the reset pots endpoint
 */
export interface ResetPotsResponse {
  deletedAllocations: number;
  deletedDeductions: number;
  deletedPots: number;
  deletedPeriods: number;
  deletedEvents: number;
  timeReset: boolean;
  currentTime: string;
}

/**
 * API client for pot reset operations
 */
export const potsApi = {
  /**
   * Reset all pot data for the organisation and reset time to system time.
   * Deletes allocations, deductions, pots, periods, and events.
   * @returns Promise with deletion counts and current time
   */
  resetPots: async (): Promise<ResetPotsResponse> => {
    const response = await apiClient.delete<ResetPotsResponse>('/api/dev/pots');
    return response.data;
  },
};
